import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            {featuresData.title}
          </h2>
          <p className="text-sm text-foreground-600">为什么选择51黑料网作为您的黑料导航入口</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuresData.items.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-6 flex flex-col items-center text-center gap-3"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-accent-100 rounded-2xl">
                <i className={`${item.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 font-heading">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}